import React from 'react';
import { product } from './Datatype';

interface props {
  products: product[];
  openedit: (item: product) => void;
  deleteproduct: (item: product) => void;
  changestatus: (item: product, status: string) => void;
}

const ProductTable: React.FC<props> = ({ products, openedit, openview, deleteproduct, changestatus }) => {
  const rows = products.map((item, i) => (
    <tr key={item._id || i}>
      <td style={{ width: '60px' }}>
        <select 
          className="action-select" 
          value="" 
          onChange={(e) => {
            e.target.value === "edit" && openedit(item);
            e.target.value === "delete" && deleteproduct(item);
            e.target.value === "active" && changestatus(item, "active");
            e.target.value === "inactive" && changestatus(item, "inactive");
            e.target.value === "view" && openview(item);

          }}
        >
          <option value="" disabled>{i + 1}</option>
          <option value="edit">edit</option>
          <option value="view">view</option>
          <option value="active">set active</option>
          <option value="inactive">set inactive</option>
          <option value="delete">delete</option>
        </select>
      </td>
      <td><strong>{item.sku}</strong></td>
      <td>{item.name}</td>
      <td>{item.price}</td>
      <td>{item.status}</td>
    </tr>
  ));

  return (
    <table className="grid">
      <thead>
        <tr>
          <th>action</th>
          <th>sku</th>
          <th>name</th>
          <th>price</th>
          <th>status</th>
        </tr>
      </thead>
      <tbody>
        {rows.length > 0 ? rows : (
          <tr>
            <td colSpan={5} style={{ textAlign: 'center', padding: '16px' }}>No products found</td>
          </tr>
        )}
      </tbody>
    </table>
  );
};

export default ProductTable;